import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';

import EmployeeShow from '../pages/employees/show';
import EmployeeChangeImpacts from '../pages/employees/change-impacts';
import EmployeeTasks from '../pages/employees/tasks';
import EmployeeStakeholderProfiles from '../pages/employees/stakeholder-profiles';

export const employeeRoutes = () => (
  <>
    <Route path={ROUTES.EMPLOYEES_SHOW} element={<EmployeeShow />} />
    <Route
      path={ROUTES.EMPLOYEES_CHANGE_IMPACTS}
      element={<EmployeeChangeImpacts />}
    />
    <Route path={ROUTES.EMPLOYEES_TASKS} element={<EmployeeTasks />} />
    <Route
      path={ROUTES.EMPLOYEES_STAKEHOLDER_PROFILES}
      element={<EmployeeStakeholderProfiles />}
    />
  </>
);
